import { useEffect, useRef } from 'react';

import type {
  NotificationMessage,
  NotificationSubscription,
} from '@/app/providers/notifications-ws-provider';
import { useNotificationsWSContext } from '@/app/providers/notifications-ws-provider';

export type { NotificationMessage, NotificationSubscription };

type UseNotificationsWSOptions = {
  subscription: NotificationSubscription | null;
  onMessage: (msg: NotificationMessage) => void;
};

export function useNotificationsWS({ subscription, onMessage }: UseNotificationsWSOptions) {
  const { isConnected, subscribe } = useNotificationsWSContext();
  const onMessageRef = useRef(onMessage);
  onMessageRef.current = onMessage;

  useEffect(() => {
    if (!subscription) {
      return;
    }
    return subscribe(subscription, (msg) => onMessageRef.current(msg));
  }, [subscribe, subscription?.resource_id, subscription?.resource_type]);

  return { isConnected };
}
